import { useState } from 'react';
import { faqs } from '@/mocks/manga';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="mb-8">
        <p className="text-xs text-foreground-500 uppercase tracking-widest mb-2">
          FAQ
        </p>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
          常见问题
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-background-50 rounded-xl overflow-hidden"
          >
            <button
              onClick={() => toggleFaq(index)}
              className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
            >
              <h4 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                {faq.question}
              </h4>
              <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 ${
                openIndex === index
                  ? 'bg-accent-500 text-background-50 rotate-45'
                  : 'bg-foreground-100 text-foreground-600'
              }`}>
                <i className="ri-add-line text-sm"></i>
              </div>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96 pb-4 md:pb-5 px-4 md:px-5' : 'max-h-0'
              }`}
            >
              <p className="text-sm text-foreground-600 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}